import axios from 'axios'
import { Auth } from 'aws-amplify'
import { getJWT } from '../utils/functions'

const iseeBaseURL = import.meta.env.VITE_BACKEND
const flowvuBaseURL = import.meta.env.VITE_FLOWVU_BACKEND
const chatvuBaseURL = import.meta.env.VITE_CHATVU_BACKEND
const aivuBaseURL = import.meta.env.VITE_AIVU_BACKEND
const aivuSecret = import.meta.env.VITE_AIVU_SECRET

const requestFunction = async (config) => {
  const token = await getJWT().catch(() => {
    window.location.reload(false)
  })
  if (token) {
    // Ensure headers object exists
    if (!config.headers) {
      config.headers = {}
    }
    // For axios, use config.headers directly (not config.headers.common)
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}

const errorFunction = async (error) => {
  // Do something with request error
  return Promise.reject(error)
}

const headers = {
  'Content-Type': 'application/json'
}

const iseeInstance = axios.create({
  baseURL: iseeBaseURL,
  timeout: 10000, // timeout selected to accomodate portal loading
  headers
})

const flowvuInstance = axios.create({
  baseURL: flowvuBaseURL,
  timeout: 30000, // timeout selected to accomodate large file upload
  headers
})

const chatvuInstance = axios.create({
  baseURL: chatvuBaseURL,
  timeout: 30000,
  headers
})

// aiVU-backend (segmentation / wound measurement). Not Cognito-authed — uses an
// optional shared secret header. Longer timeout for CPU MedSAM inference.
const aivuInstance = axios.create({
  baseURL: aivuBaseURL,
  timeout: 60000,
  headers: aivuSecret ? { ...headers, 'X-Agent-Secret': aivuSecret } : headers
})

iseeInstance.interceptors.request.use(requestFunction, errorFunction)
flowvuInstance.interceptors.request.use(requestFunction, errorFunction)
chatvuInstance.interceptors.request.use(requestFunction, errorFunction)

const responseErrorFunction = async (error) => {
  if (error.response?.status === 401) {
    try {
      await Auth.signOut()
    } catch (e) {
      window.location.reload()
    }
  }
  return Promise.reject(error)
}

iseeInstance.interceptors.response.use(response => response, responseErrorFunction)
flowvuInstance.interceptors.response.use(response => response, responseErrorFunction)
chatvuInstance.interceptors.response.use(response => response, responseErrorFunction)

export { iseeInstance, flowvuInstance, chatvuInstance, aivuInstance }
